<template>
  <div>
    <p v-if="regionalCreditScoreGrade && !displayEquifaxBranding" data-test="postalCodeInfo">
      {{ $t('message.credit.alternateCreditVisionInfo') }}
    </p>
    <Notification :text="$t('message.credit.notification')"> </Notification>
    <CreditResultDetails class="mt-4" :creditRange="shownGrade"> </CreditResultDetails>
    <div v-if="isKijijiDealer && isEquifaxIDAuthNeighbourhood">
      <TradeCTA v-if="displayTradeCTA" data-test="tradeCTA"></TradeCTA>
      <p class="font-size-10 color-primary-grey pt-2" data-test="disclaimerEquifaxIDAuth">
        {{ $t('message.credit.disclaimer.equifaxIdAuthKijiji') }}
      </p>
    </div>
    <ApplyNow v-else-if="financeApplicationEnabled"></ApplyNow>
    <p v-if="displayEquifaxBranding" class="font-size-10 color-primary-grey" data-test="disclaimer">
      {{ $t('message.credit.disclaimer.equifax') }}
    </p>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import CreditResultDetails from '@/components/credit-results/CreditResultDetails.vue';
import Notification from '@/components/shared/Notification.vue';
import ApplyNow from '@/components/credit/ApplyNow.vue';
import creditDataSourceCA from '@/utils/enums/creditDataSourceCA';
import TradeCTA from '@/components/credit-results/TradeCTA.vue';
import { AVRProducts } from '@/utils/enums';

export default {
  name: 'EquifaxAndRegionalCreditResults',
  components: {
    TradeCTA,
    ApplyNow,
    CreditResultDetails,
    Notification,
  },
  computed: {
    ...mapGetters('credit', ['creditScoreGrade', 'regionalCreditScoreGrade']),
    ...mapGetters('business', [
      'financeApplicationEnabled',
      'isKijijiDealer',
      'displayEquifaxBranding',
      'getDefaultCreditDataSourceCA',
      'getSubscribedProducts',
    ]),
    shownGrade() {
      // if equifax fails we will default to regional credit
      return this.creditScoreGrade ? this.creditScoreGrade : this.regionalCreditScoreGrade;
    },
    isEquifaxIDAuthNeighbourhood() {
      return this.getDefaultCreditDataSourceCA === creditDataSourceCA.EQUIFAX_ID_AUTH_NEIGHBOURHOOD_CREDIT;
    },
    displayTradeCTA() {
      return (
        this.getSubscribedProducts.includes(AVRProducts.TRADE) &&
        this.$store.state.dhs.products.trade.state !== this.enums.DHSState.COMPLETE
      );
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/scss/variables';
</style>
